import { Component } from '@angular/core';
import { teamHeroSources } from '../../component/team-hero-sources';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import { TranslateModule } from '@ngx-translate/core';
import {
  ParkourBlockPlaceholderComponent,
  ParkourDividerComponent,
  ParkourHeroComponent,
  ParkourPageImageComponent,
} from '@parkour/ui';
import { AsyncPipe } from '@angular/common';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import { ParkourPage } from '../../../shared/parkour-page';
import { ProfielService } from '../../../profiel/service/profiel.service';

@Component({
  standalone: true,
  templateUrl: './team-no-team.page.html',
  imports: [
    ParkourBackButtonDirective,
    TranslateModule,
    ParkourPageImageComponent,
    AsyncPipe,
    ParkourHeroComponent,
    ParkourDividerComponent,
    ParkourBlockPlaceholderComponent,
    PageLayoutComponent,
    IonRefresher,
    IonRefresherContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonTitle,
    IonBackButton,
    IonContent,
    ParkourRefreshDirective,
  ],
})
export class TeamNoTeamPage extends ParkourPage {
  profiel$ = this.profielService.getCurrentUserProfiel$();

  constructor(private readonly profielService: ProfielService) {
    super();
  }

  protected readonly teamHeroSources = teamHeroSources;
}
